module.exports = __webpack_public_path__ + "static/farshchi-f7964d766725f141c626dc07a6712ae1.jpg";